import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import Auth from "@/controller/auth";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "Home",
    component: () => import("../views/Home.vue"),
    children: [
      {
        path: "/user-profile",
        name: "UserProfile",
        component: () => import("../views/UserProfile.vue")
      },
      {
        path: "/chat",
        name: "Chat",
        component: () => import("../views/Chat.vue")
      },
      {
        path: "/skin-profile",
        name: "SkinProfile",
        component: () => import("../views/SkinProfile.vue")
      }
    ]
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/Login.vue")
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("../views/Register.vue")
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

router.beforeEach((to, from, next) => {
  if (to.name !== "Login" && to.name !== "Register" && !Auth.isAuth()) {
    next("/login");
    return;
  }

  if (to.name === "Register" && Auth.isAuth()) {
    next("/");
    return;
  }

  if (to.name === "Home" && Auth.isAuth()) {
    next("/user-profile");
    return;
  }

  next();
});

export default router;
